// @flow

import styled from 'styled-components';
import type { Theme } from '../../../types';

export const Header = styled<any, Theme>('header')`
  align-items: center;
  display: flex;
`;

export const ContactList = styled<any, Theme>('ul')`
  margin: 0;
  padding: 1rem 0 0 0;
  list-style: none;
  background-color: ${props => props.theme.menu.touch.contact.backgroundColor};
  flex-grow: 1;
  .contact-item {
    border-bottom: 0;
    background-color: transparent;
    i {
      font-size: 1.4rem;
      line-height: 0;
      &:before {
        vertical-align: middle;
      }
    }
    .contact-item-label {
      padding-left: 1rem;
    }
    .contact-item-link {
      display: flex;
      align-items: center;
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
      color: ${props => props.theme.menu.touch.contact.color};
    }
  }
`;

export const ToggleButton = styled<any, Theme>('button')`
  align-items: center;
  background-color: ${props => props.theme.menu.touch.toggleButton.backgroundColor};
  border-radius: ${props => props.theme.menu.touch.toggleButton.borderRadius};
  border: 1px solid ${props => props.theme.menu.touch.toggleButton.borderColor};
  color: ${props => props.theme.menu.touch.linkColor};
  cursor: pointer;
  display: flex;
  font-size: 1rem;
  outline: none;
  padding: 0.6rem;
  transition: background-color 200ms ease-in;

  .label {
    margin-left: 0.5rem;
  }

  &:hover {
    background-color: ${props => props.theme.menu.touch.toggleButton.backgroundHoverColor};
  }
`;

export const StyleWrapper = styled<any, Theme>('section')`

  /* Main properties */

  cursor: default;

  /* Main elements */

  a {
    color: ${props => props.theme.menu.touch.linkColor};
    cursor: pointer;
    display: block;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5rem;
    padding: 1rem 1.5rem;
    text-decoration: none;
  }

  .icon-hamburger {
    font-size: 1.4rem;
    line-height: 0;
    &:before {
      vertical-align: middle;
    }
  }

  nav {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
    position: fixed;
    right: 0;
    transition: transform 400ms ease-in-out;
    transform: translateX(-100%);
    top: 0;
    width: 100vw;

    &.toggled {
      transform: translateX(0);
    }
  }

  ul[class*="level-"] {
    background-color: ${props => props.theme.menu.touch.subItem.backgroundColor};
    list-style: none;
    margin: 0;
    padding: 0;

    &.has-parent {
      height: 100%;
      left: 0;
      position: absolute;
      transition: 400ms ease-in-out;
      transform: translateX(-100%);
      top: 0;
      visibility: hidden;
      width: 100%;
      z-index: 1;
    }
  }

  li {
    background-color: ${props => props.theme.menu.touch.item.backgroundColor};
    border-bottom: ${props => props.theme.menu.touch.item.border};
    transition: background-color 200ms ease-in;

    a:hover, a.active, a.has-active-child {
      background-color: ${props => props.theme.menu.touch.item.backgroundHoverColor};
    }

    .parent-label {
      color: ${props => props.theme.menu.touch.linkColor};
      font-weight: bold;
      padding: 0;

      .link {
        font-weight: bold;
        padding: 1.4rem;
      }
    }

    .link-label {
      align-items: center;
      display: flex;

      .link-icon {
        margin-right: 1rem;
      }
    }

    &.has-parent {
      visibility: hidden;
    }

    &.active > .has-parent,
    &.has-active-child > .has-parent {
      transform: translateX(0);
      visibility: visible;
    }

    &.has-children {
      a {
        align-items: center;
        display: flex;
        justify-content: space-between;
      }
      .arrow {
        border: solid ${props => props.theme.menu.touch.linkColor};
        border-width: 0 0.1rem 0.1rem 0;
        display: inline-block;
        padding: 0.25rem;
        transform: rotate(-45deg);
      }
    }
  }

  /* Specific class names */

  .header {
    background-color: ${props => props.theme.menu.touch.header.backgroundColor};
    display: flex;
    justify-content: space-between;
    padding: 1rem 1rem 1rem 1.5rem;

    .title {
      color: ${props => props.theme.menu.touch.header.titleColor};
      font-size: 1.2rem;
    }

    .back-link {
      background-color: transparent;
      align-items: center;
      cursor: pointer;
      display: flex;
      font-size: 0.9rem;
      outline: none;
      padding: 0;

      .arrow {
        border-width: 0 0.1rem 0.1rem 0;
        border-style: solid;
        border-color: ${props => props.theme.menu.touch.backLink.arrowColor};
        display: inline-block;
        padding: 0.25rem;
        transform: rotate(135deg);
      }

      .label {
        margin-left: 0.2rem;
        color: ${props => props.theme.menu.touch.backLink.labelColor};
      }
      &:hover {
        color: ${props => props.theme.menu.touch.backLink.hoverColor};

        .arrow {
          border-color: ${props => props.theme.menu.touch.backLink.hoverColor};
        }
      }
    }

    .close-button {
      background-color: transparent;
      border: 0;
      color: ${props => props.theme.menu.touch.closeButton.color};
      cursor: pointer;
      outline: none;
      transition: transform 200ms ease-in;
      .icon-cross {
        font-size: .95rem;
        line-height: 0;
        &:before {
          vertical-align: middle;
        }
      }
      &:hover {
        color: ${props => props.theme.menu.touch.closeButton.hoverColor};
      }
    }
  }
`;

export default StyleWrapper;
